/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Manual_WardInputs */

const vi_carrier_manual_ward = /** @type {(inputs: Carrier_Manual_WardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã phường/xã (hãng)`)
};

/**

* @param {Carrier_Manual_WardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_manual_ward = /** @type {((inputs?: Carrier_Manual_WardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Manual_WardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_manual_ward(inputs)
});